import { Heading, IconButton, Spinner } from '@ui'
import React, { ReactNode } from 'react'
import { HiArrowLeft, HiArrowPath } from 'react-icons/hi2'

interface IProps {
  title?: string
  onActionClick?: () => void
  refreshAction?: () => void
  isRefreshing?: boolean
  leftItem?: ReactNode
}

export const Titlebar = ({
  title,
  onActionClick,
  refreshAction,
  isRefreshing,
  leftItem,
}: IProps) => {
  return (
    <div className="mb-3 grid min-h-10 grid-cols-[40px_1fr_40px] items-center gap-2">
      {onActionClick ? (
        <IconButton aria-label="Back" onClick={onActionClick}>
          <HiArrowLeft />
        </IconButton>
      ) : (
        <span />
      )}
      <Heading level={5} align="center" truncate>
        {title}
      </Heading>
      <div className="flex justify-end">
        {refreshAction ? (
          isRefreshing ? (
            <span className="grid size-10 place-items-center text-fg-2">
              <Spinner size={20} />
            </span>
          ) : (
            <IconButton aria-label="Refresh" onClick={refreshAction}>
              <HiArrowPath />
            </IconButton>
          )
        ) : (
          leftItem
        )}
      </div>
    </div>
  )
}
